<template>
    <div class="wk-percbar">
        <div class="wk-percbar__inner"
             v-bind:style="style"></div>

        <div class="wk-percbar__text">
            <span class="wk-percbar__prefix">{{prefix}}</span>
            <span class="wk-percbar__value">{{value}}%</span>
        </div>
    </div>
</template>

<script>
    import { timeout } from 'donot';

    export default {
        data() {
            return {
                style : ''
            }
        },

        async mounted() {
            await timeout(300);

            this.style = {
                width : `${this.value}%`
            }
        },

        props : {
            prefix : {
                type : String,
            },

            value : {
                type : Number,
                default : 0
            }
        }
    }
</script>